export const MAX_RESPONSIVE_WIDTH = '(max-width:900px)';
export const ALL_SEMESTER = '모든 학기';
